import React from 'react';
import type {MessageDescriptor} from 'react-intl';
import {DownloadCsvButton} from '@igp/shared/components/download';

import {useDebtTransferLogDownload} from '../hooks';
import type {DebtTransferLogViewModelKeys} from '../types';

type DebtTransferLogDownloadButtonProps = {
    keys: DebtTransferLogViewModelKeys[];
    filter: string;
    filename: MessageDescriptor;
    total: number;
    disabled?: boolean;
    mode: 'client' | 'server';
};

export function DebtTransferLogDownloadButton({disabled, ...props}: DebtTransferLogDownloadButtonProps) {
    const {handleDownload, isProgress} = useDebtTransferLogDownload(props);
    return <DownloadCsvButton onClick={handleDownload} loading={isProgress} disabled={disabled || isProgress} />;
}
